<template>
    <div class="pr-1 pt-0 pb-2 pl-2" style="position: relative;">
        <div class="bid-header primary--text">
            {{ manufacturer }} - {{ bidNumber }}
        </div>

        <div class="calculation-header pr-0 pl-2 v-flex" >
            <div class = "calculation-col-header elevator">

            </div>
            <div class = "calculation-col-header prices">
                Angebotspreis
            </div>
            <div class = "calculation-col-header prices">
                Kosten
            </div>
        </div>
        <div class="calculation-header pr-0 pl-2 v-flex" >
            <div class = "calculation-col-header elevator">
                {{ $t('inc.unit.elevatorNo') }}
            </div>
            <div class = "calculation-col-header price">
                Urspünglich
            </div>
            <div class = "calculation-col-header price">
                Empfohlen
            </div>
            <div class = "calculation-col-header price">
                Material
            </div>
            <div class = "calculation-col-header price">
                Lohn
            </div>
        </div>

        <div v-for="(calculation, index) in bid.calculations"
             :key = "index"
             class="v-flex calculation-border pa-2 pr-0"
             :class="border(index)"
        >
            <div class="elevator">
                {{ calculation.unit.fabricNo }}
            </div>
            <div class="price">
                {{ money (calculation.priceOriginal) }}
            </div>
            <div class="price">
                {{ money (calculation.priceRecommended) }}
            </div>
            <div class="price">
                {{ money (calculation.costMaterial) }}
            </div>
            <div class="price">
                {{ money (calculation.costWage) }}
            </div>
        </div>
        <div class="v-flex calculation-border pa-2 bottom-border-radius background-selected" v-if="bid.calculations.length > 1">
            <div class="elevator background-selected">
                Summe
            </div>
            <div class="price ">
                {{ money (bid.priceOriginal) }}
            </div>
            <div class="price">
                {{ money (bid.priceRecommended) }}
            </div>
            <div class="price">
                {{ money (bid.costMaterial) }}
            </div>
            <div class="price">
                {{ money (bid.costWage) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PIncBidSummary",

    props: {
        bid: {

        }
    },

    computed: {
        manufacturer () {
            return this.bid.manufacturer ? this.bid.manufacturer.name : "---";
        },

        bidNumber () {
            return this.bid.number ? this.bid.number : "---";
        },
    },

    methods: {
        border (index) {
            if (index === 0) {
                if (this.bid.calculations.length > 1) {
                    return "top-border-radius";
                } else {
                    return "top-bottom-border-radius";
                }
            }

            return "middle-border-radius";
        },

        money (value) {
            if (!value) {
                return "---"
            }

            return this.$n(value, 'currency');
        }
    }
}
</script>

<style scoped>

.bid-header {
    font-size: 14px;
    font-weight: 600;
    padding-left: 8px;
    position: absolute;
    top: -2px;
    left: 5px;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.calculation-header {
    min-height: 15px;
    width: 700px;
    display: flex;
}

.elevator {
    width: 150px;
    font-size: 15px;
}

.price {
    width: 110px;
    text-align: right;
    font-size: 15px;
}

.calculation-header .price {
    text-align: right;
}

.calculation-header .prices {
    width: 200px;
    text-align: center;
    padding-left: 60px;
}

.calculation-col-header {
    font-size: 12px;
    padding-left: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.calculation-border {
    border-style: solid;
    border-width: 1px;
    border-color: lightgray !important;
}

</style>